// extracted by mini-css-extract-plugin
export default {"sortingHat":"SortingHat_sortingHat__tDSRd"};